import { MobXProviderContext } from 'mobx-react';
import { Suspense, useMemo } from 'react';
import { QueryClientProvider } from 'react-query';
import { I18nextProvider } from 'react-i18next';
import { AppProvider } from '@view/providers';
import queryClient from '@data/api/queryClient';
import Loader from '@view/components/Loader';
import Root from '@view/pages/Root';
import i18n from '@data/other/i18n';
import { initializeStore } from '@data/stores/Store';

import './App.scss';

type Props = { storeLoader: ReturnType<typeof initializeStore> };

const AppInner = ({ storeLoader }: Props) => {
  const stores = useMemo(() => ({ store: storeLoader() }), [storeLoader]);

  return (
    <MobXProviderContext.Provider value={stores}>
      <QueryClientProvider client={queryClient}>
        <AppProvider>
          <I18nextProvider i18n={i18n}>
            <Root />
          </I18nextProvider>
        </AppProvider>
      </QueryClientProvider>
    </MobXProviderContext.Provider>
  );
};

const App = () => (
  <Suspense fallback={<Loader fixed large />}>
    <AppInner storeLoader={initializeStore()} />
  </Suspense>
);

export default App;
